module.exports = (formValues, qty) => {
  let participants = []
  for (let i = 0; i < qty; i++) {
    let participantForm = {}
    for (let key in formValues) {
      if (key.includes(i)) {
        let newKey = key.split('-')
        newKey.pop()
        newKey = newKey.join('_')
        participantForm[newKey] = formValues[key]
      }
    }
    participants.push(participantForm)
  }
  // // handling value t-shirt size
  // participants = participants.map((participant) => {
  //   // check if participant input t-shirt size
  //   if (participant.t_shirt_size && participant.t_shirt_size !== '') {
  //     // check if participant input notes
  //     if (participant.notes && participant.notes !== '') {
  //       participant.notes = `Polo Shirt Size: ${participant.t_shirt_size}. Notes: ${participant.notes}.`
  //       delete participant.t_shirt_size // remove key object : t_shirt_size
  //       return participant
  //     } else {
  //       participant.notes = `Polo Shirt Size: ${participant.t_shirt_size}.`
  //       delete participant.t_shirt_size // remove key object : t_shirt_size
  //       return participant
  //     }
  //   } else {
  //     delete participant.t_shirt_size // remove key object : t_shirt_size
  //     return participant
  //   }
  // })
  return participants
}